<template>
  <div class="monitoringParent">
    <div class="container-router">
      <div class="container-router__back" @click.stop="goListCampaign()">
        <span class="container-router__back__icon"><i class="adx-ic_arrow_left"></i></span>
        <span class="container-router__back__all subhead">Static Advertising</span>
      </div>
      <div class="title">
        <h1 class="medium-title">Campaign Monitoring</h1>
        <ul class="title__menu">
          <router-link v-if="idooh_campaign.length > 0" tag="li" :to="{name: 'digitalscrmonitoring', query : this.query_route}">Digital Screen</router-link>
          <router-link v-if="static_campaign" tag="li" :to="{name: 'exbrandmonitoring', query: this.query_route }">Experience Branding</router-link>
        </ul>
      </div>
      <router-view />
    </div>
  </div>
</template>

<script>
import TransactionItem from '@/views/Transaction/TransactionItem'
import SideBar from '@/components/SideBar/Desktop'
import Loading from '@/components/Loading/Primary'
import Pagination from '@/components/Pagination'
import table from '@/components/Table'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import { mapGetters } from 'vuex';

export default {
  name: 'adx-',
  components: {
    'transaction-item': TransactionItem,
    "adx-sidebar": SideBar,
    'adx-loading': Loading,
    'adx-pagination': Pagination,
    'adx-table': table
  },
  props: {

  },
  data() {
    return {
      items: [],
      isLoading: false,
      campaignId: null,
      idooh_campaign: [],
      static_campaign: null,
      query_route: null
    }
  },
  computed: {
    ...mapGetters({
      user: 'account',
    }),
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    this.campaignId = this.$route.params.id
    this.query_route = this.$route.query
    this.loadData()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
  async loadData(){
    let response = null
    response = await api.get(apiV2.dashboardParentCampaign(this.campaignId), {needToken:true});
    if (response.status == 200) { 
      this.idooh_campaign = response.data.idooh_campaign
      this.static_campaign = response.data.static_campaign
    }
  },
  goListCampaign() {
      this.$router.push({ name: 'advertiserstatic', query: this.query_route})
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
